import { errorFromResponse } from './problem';

interface FetchResult<T> {
  data?: T;
  error?: unknown;
  response: Response;
}

/**
 * Returns the data of an openapi-fetch result or throws ApiError (problem body) or HttpError, so
 * query and mutation functions can simply `return unwrap(await client.GET(...))`.
 */
export function unwrap<T>(result: FetchResult<T>): T {
  if (result.error !== undefined || !result.response.ok) {
    throw errorFromResponse(result.response.status, result.error);
  }
  return result.data as T;
}
